<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      
      <ng-container *ngIf="!isSearchResult && headerV2">
        <div class="split-heading left-section mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
          <img-with-placeholder [placeholder]="'/landing-split/landing_split_placeholder.webp' | assetUrl">
            <picture>
              <source
                [srcset]="'/landing-split/landing_split_380_4.webp' | assetUrl"
                media="(min-width: 600px) and (max-width: 839px)"
              />
              <source
                [srcset]="'/landing-split/landing_split_502_4.webp' | assetUrl"
                media="(min-width: 840px)"
              />
              <img
                  fullSizedImage
                  [srcset]="('/landing-split/landing_split_398.webp 1x' | assetUrl) + ',' + ('/landing-split/landing_split_398@2.webp 2x' | assetUrl) + ',' + ('/landing-split/landing_split_398@3.webp 3x' | assetUrl)"/>
            </picture>
          </img-with-placeholder>
          
          <div class="heading-title" [ngClass]="!isDesktop ? 'mat-body-1' : 'mat-headline-6'"><b i18n>We'll sell for you</b></div>
          <div class="heading-description" [ngClass]="!isDesktop ? 'mat-body-1' : 'mat-body-1'" i18n>Pack your items in a box, and we'll handle the rest!</div>
          <button 
              mat-raised-button
              class="heading-button"
              (click)="toGreenBox()" 
              color="accent"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Landing header"
              angularticsLabel="ORDER BOX"
              i18n>ORDER BOX</button>
        </div>
        
        <div class="split-heading right-section mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
          <img-with-placeholder [placeholder]="'/landing-split/landing_split_right_placeholder.webp' | assetUrl">
            <picture>
              <source
                [srcset]="'/landing-split/landing_split_right_380_2.webp' | assetUrl"
                media="(min-width: 600px) and (max-width: 839px)"
              />
             <source
                [srcset]="'/landing-split/landing_split_right_502_3.webp' | assetUrl"
                media="(min-width: 840px)"
              />
              <img
                  fullSizedImage
                  [srcset]="('/landing-split/landing_split_right_398.webp 1x' | assetUrl) + ',' + ('/landing-split/landing_split_right_398@2.webp 2x' | assetUrl) + ',' + ('/landing-split/landing_split_right_398@3.webp 3x' | assetUrl)"/>
            </picture>
          </img-with-placeholder>
        
          <div class="heading-title" [ngClass]="!isDesktop ? 'mat-body-1' : 'mat-headline-6'"><b i18n="right section title on landing page">Snap&Sell</b></div>
          <div class="heading-description" [ngClass]="!isDesktop ? 'mat-body-1' : 'mat-body-1'" i18n>Our AI transforms a few photos into complete sales listings for you</div>
          <button 
              mat-raised-button 
              (click)="toSnapAndSell()" 
              color="accent"
              class="heading-button"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Landing header"
              angularticsLabel="SEE HOW IT WORKS"
              i18n>SEE HOW IT WORKS</button>
        </div>
      </ng-container>
    
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div *ngIf="!loading && currentQuery && noListedSearchResults">
          <p i18n>Looks like no-one is yet selling what you’re looking for, but make sure to check back soon. Our database is growing fast.</p>
        </div>
        <div *ngIf="latest">
          <h1 i18n>Latest listings</h1>
        </div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2" *ngFor="let item of items">
        <item-tile [item]="item"/>
      </div>
      <div [hidden]="!loading" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div class="spinner">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <div *ngIf="items.length !== 0" [hidden]="loading" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" style="text-align: center">
        <button
            mat-raised-button 
            (click)="seeMore()" 
            angulartics2On="click" angularticsAction="SeeMoreClick"
            i18n="button to show more search results">SEE MORE</button>
      </div>
    </div>
  </div>
</div>